class ImageWithTextSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const element = this.hasAttribute("data-flickity-settings")
      ? this
      : this.querySelector("[data-flickity-settings]");

    // Parse existing data-flickity-settings and merge with JavaScript options
    const dataSettings = element.dataset.flickitySettings
      ? JSON.parse(element.dataset.flickitySettings)
      : {};
    const jsSettings = { adaptiveHeight: true, resize: true };
    const mergedSettings = { ...dataSettings, ...jsSettings };

    const flckty = new Flickity(element, mergedSettings);
    console.log("Data settings:", dataSettings);
    console.log("Merged settings:", mergedSettings);
    console.log("Final Flickity options:", flckty.options.adaptiveHeight);
    console.log(flckty);
    flckty.on("select", (e) => {
      console.log("select", e);
    });
    flckty.on("ready", (e) => {
      console.log("ready", e);
    });
    document
      .querySelectorAll(".image-with-text-slider__buttons")
      .forEach((buttonsContainer) => {
        const prevBtn = buttonsContainer.querySelector(
          ".image-with-text-slider__prev-btn"
        );
        const nextBtn = buttonsContainer.querySelector(
          ".image-with-text-slider__next-btn"
        );
        if (prevBtn) {
          prevBtn.addEventListener("click", (e) => {
            flckty.previous();
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener("click", (e) => {
            flckty.next();
          });
        }
      });
  }
}

customElements.define("image-with-text-slider", ImageWithTextSlider);
